export default __webpack_public_path__ + "static/media/image-2.db0312c5.png";